"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getList = void 0;
const validation_1 = __importDefault(require("../../../../../../validation"));
const types_1 = require("../types");
const getListParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
    lawId: validation_1.default.rules.string().required().label('Law Id'),
    state: validation_1.default.rules.string().oneOf([
        types_1.ApplicableLawState.NO_ACTION,
        types_1.ApplicableLawState.BEST_PRACTICE_REQUIREMENTS,
        types_1.ApplicableLawState.IMPROVE_LEGAL_PRACTICE,
        types_1.ApplicableLawState.DISCLOSURE_REQUIREMENTS,
    ]).label('State of privacyIssues'),
};
const getListParams = {
    rules: getListParamRules,
    schema: validation_1.default.schema(getListParamRules),
};
const getListQueryRules = {
    offset: validation_1.default.rules.string().integer().label('Offset'),
    limit: validation_1.default.rules.string().integer().label('Limit'),
};
const getListQuery = {
    rules: getListQueryRules,
    schema: validation_1.default.schema(getListQueryRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.getList = {
    params: getListParams,
    query: getListQuery,
};
